import { useState, useEffect } from 'react';
import useAuth from 'hooks/useAuth';

import PartnerDashboard from '../custom/PartnerDashboard'
import { useNavigate } from "react-router-dom";
import axios from "axios";
export default function PartnerPage() {
		const auth = useAuth();
	const [pageReady, setPageReady] = useState(true);
	  const navigate = useNavigate();
    useEffect(() => {
        const checkPartnerShop = async () => {
            try {
                const userId = auth.userId;
               const response = await axios.get(
               `${process.env.REACT_APP_API_PATH}partner/check/${userId}`,
    {
        headers: {
            Authorization: `Bearer ${auth.token}`
        }
    }
);
                if (!response.data.exists) {
                    navigate("/partnershops/add");
                }
            } catch (err) {
                console.error(err);
            }
        };
        checkPartnerShop();
    }, [navigate]);
	return (
		<main id="PartnerPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <div className="">
                    <PartnerDashboard/>
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
